import React from 'react';
import { Outlet, useLocation, Link } from 'react-router-dom';
import Header from '../components/Header';

const TopLayout: React.FC = () => {
    const location = useLocation();

    const isActive = (path: string) => {
        return location.pathname === `/top${path}`;
    };

    return (
        <div className={"Page TopPage postsList"}>
            <Header />
            <nav className="sub-nav">
                <Link 
                    to="/top/last24h"
                    className={`sub-nav-item ${isActive('') || isActive('/last24h') ? 'active' : ''}`}
                >
                    Dernières 24h
                </Link>
                <Link 
                    to="/top/thismonth"
                    className={`sub-nav-item ${isActive('/thismonth') ? 'active' : ''}`}
                >
                    Ce mois
                </Link>
                <Link 
                    to="/top/thisyear"
                    className={`sub-nav-item ${isActive('/thisyear') ? 'active' : ''}`}
                >
                    Cette année
                </Link>
            </nav>
            <div className="top-content">
                <Outlet />
            </div>
        </div>
    );
};

export default TopLayout;
